const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2E75B6', paddingBottom:'8px', marginBottom:'24px', color:'#1F3864' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#2E75B6', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2E75B6', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#EBF3FB', border:'2px solid #2E75B6', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#1F3864', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2E75B6' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#2E75B6', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#f5f9ff' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#1F3864', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f8fbff', border:'1px solid #ccd9ea', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#1F3864', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Formula / Notes</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Numerical Differentiation ─────────────────────────
function DiagramNumericalDiff() {
  const W = 900, H = 370;
  const cx = 200, cy = 240, sc = 58;
  const tx = x => cx + x * sc;
  const ty = y => cy - y * sc;

  const f  = x => 0.18*x*x*x - 0.4*x + 1.1;
  const fp = x => 0.54*x*x - 0.4;   // true derivative

  const x0 = 1.2, h = 1.0;
  const x0s = x0, hS = 0.45; // small h for centred demo

  // Three secant lines
  const secants = [
    { h: 1.0,  color: '#e07b00', label: 'Forward h=1.0',  type: 'forward' },
    { h: 0.45, color: '#9b59b6', label: 'Centred h=0.45', type: 'centred' },
    { h: 0.15, color: '#27ae60', label: 'Forward h=0.15', type: 'forward' },
  ];

  // True tangent at x0
  const slope0 = fp(x0);
  const tanX1 = x0 - 1.2, tanX2 = x0 + 1.4;

  // Curve points
  const curvePts = [];
  for (let x = -0.3; x <= 3.1; x += 0.05) {
    const y = f(x);
    if (y > -0.5 && y < 3.5) curvePts.push([tx(x), ty(y)]);
  }
  const curveD = curvePts.map((p,i) => `${i===0?'M':'L'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ');

  const px0 = 448, panW = W - px0 - 12;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Numerical Differentiation — Forward, Backward & Centred Difference</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Left panel */}
        <rect x={8} y={8} width={428} height={H-16} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={222} y={27} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Secant Approximations to the Tangent at x₀=1.2</text>

        {/* Grid */}
        {[0,1,2,3].map(v => (
          <g key={v}>
            <line x1={tx(v)} y1={50} x2={tx(v)} y2={H-40} stroke="#f0f0f0" strokeWidth="1"/>
            <text x={tx(v)} y={H-26} textAnchor="middle" fontSize="10" fill="#bbb">{v}</text>
          </g>
        ))}
        {[0,1,2,3].map(v => (
          <g key={v}>
            <line x1={tx(-0.3)} y1={ty(v)} x2={tx(3.1)} y2={ty(v)} stroke="#f0f0f0" strokeWidth="1"/>
            {v>0 && <text x={tx(-0.3)-4} y={ty(v)+4} textAnchor="end" fontSize="10" fill="#bbb">{v}</text>}
          </g>
        ))}

        {/* Axes */}
        <line x1={tx(-0.3)} y1={cy} x2={tx(3.1)} y2={cy} stroke="#1F3864" strokeWidth="1.4"/>
        <line x1={cx} y1={50} x2={cx} y2={H-38} stroke="#1F3864" strokeWidth="1.4"/>
        <text x={tx(3.1)+5} y={cy+4} fontSize="13" fill="#1F3864" fontWeight="700">x</text>
        <text x={cx+4} y={48} fontSize="13" fill="#1F3864" fontWeight="700">f</text>

        {/* Curve */}
        <path d={curveD} fill="none" stroke="#1F3864" strokeWidth="2.2"/>

        {/* True tangent */}
        <line
          x1={tx(tanX1)} y1={ty(f(x0) + slope0*(tanX1-x0))}
          x2={tx(tanX2)} y2={ty(f(x0) + slope0*(tanX2-x0))}
          stroke="#c0392b" strokeWidth="2.2" strokeDasharray="7,3"
        />
        <text x={tx(tanX2)+4} y={ty(f(x0)+slope0*(tanX2-x0))} fontSize="11" fill="#c0392b" fontWeight="700">true f'</text>

        {/* Secant lines */}
        {secants.map(({ h, color, type }, i) => {
          let xa, xb;
          if (type === 'forward')  { xa = x0;     xb = x0 + h; }
          else                     { xa = x0 - h; xb = x0 + h; }
          const slope = (f(xb) - f(xa)) / (xb - xa);
          const ext = 0.55;
          const x1e = xa - ext, x2e = xb + ext;
          return (
            <g key={i}>
              <line
                x1={tx(x1e)} y1={ty(f(xa) + slope*(x1e - xa))}
                x2={tx(x2e)} y2={ty(f(xa) + slope*(x2e - xa))}
                stroke={color} strokeWidth="1.8" opacity="0.8"
              />
              <circle cx={tx(xa)} cy={ty(f(xa))} r={4} fill={color} stroke="#fff" strokeWidth="1.5"/>
              <circle cx={tx(xb)} cy={ty(f(xb))} r={4} fill={color} stroke="#fff" strokeWidth="1.5"/>
            </g>
          );
        })}

        {/* x0 point */}
        <circle cx={tx(x0)} cy={ty(f(x0))} r={6} fill="#c0392b" stroke="#fff" strokeWidth="2"/>
        <text x={tx(x0)+8} y={ty(f(x0))-8} fontSize="12" fill="#c0392b" fontWeight="700">x₀</text>

        {/* Right panel */}
        <rect x={px0} y={8} width={panW} height={H-16} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={px0+panW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Three Finite Difference Formulas</text>

        {[
          { y:36,  bg:'#fff7ee', bc:'#e07b00', title:'Forward Difference  O(h)',
            lines:["f'(x) ≈ [f(x+h) − f(x)] / h","Uses x and x+h  →  one-sided","Error ∝ h  (first order accurate)"] },
          { y:134, bg:'#EBF3FB', bc:'#2E75B6', title:'Backward Difference  O(h)',
            lines:["f'(x) ≈ [f(x) − f(x−h)] / h","Uses x and x−h  →  one-sided","Same accuracy as forward, opposite bias"] },
          { y:232, bg:'#f8f0ff', bc:'#9b59b6', title:'Centred Difference  O(h²)',
            lines:["f'(x) ≈ [f(x+h) − f(x−h)] / (2h)","Symmetric around x  →  error cancels","Error ∝ h²  (second order — preferred)"] },
        ].map(({ y, bg, bc, title, lines }) => (
          <g key={title}>
            <rect x={px0+8} y={y+28} width={panW-16} height={88} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={px0+16} y={y+44} fontSize="12" fill="#1F3864" fontWeight="700">{title}</text>
            {lines.map((ln,i) => (
              <text key={i} x={px0+16} y={y+62+i*18} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">{ln}</text>
            ))}
          </g>
        ))}

        {/* Legend */}
        {[['#e07b00','Forward h=1.0'],['#9b59b6','Centred h=0.45'],['#27ae60','Forward h=0.15'],['#c0392b','True tangent (dashed)']].map(([color,label],i) => (
          <g key={i}>
            <line x1={px0+12} y1={H-78+i*16} x2={px0+32} y2={H-78+i*16} stroke={color} strokeWidth="2" strokeDasharray={i===3?'5,3':undefined}/>
            <text x={px0+38} y={H-73+i*16} fontSize="10.5" fill={color} fontWeight="700">{label}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Numerical differentiation replaces the limit definition f'(x) = lim(h→0)[f(x+h)−f(x)]/h with a finite step h. The centred difference uses points on both sides and achieves O(h²) accuracy — halving h quarters the error — making it far more accurate than one-sided differences for the same step size. In practice h must be chosen carefully: too large → truncation error; too small → round-off error from floating-point arithmetic.
      </div>
    </div>
  );
}

// ── Diagram 2: Numerical Integration ─────────────────────────────
function DiagramNumericalIntegration() {
  const W = 900, H = 380;
  const f = x => 0.5 + Math.sin(x * 1.1) * 0.7 + 0.15 * x;

  const a = 0.3, b = 3.9, n = 6;
  const h = (b - a) / n;
  const xs = Array.from({ length: n+1 }, (_, i) => a + i*h);

  // Panel geometry
  const PW = (W - 28) / 3;
  const p = i => 8 + i*(PW + 6);

  const makePlot = (panelX, yTop, scX, scY, cxL, cyL) => {
    const txL = x => cxL + (x - a) * scX;
    const tyL = y => cyL - y * scY;
    return { txL, tyL };
  };

  // Shared curve
  const curveForPanel = (txL, tyL, x0, x1) => {
    const pts = [];
    for (let x = x0; x <= x1; x += 0.04) pts.push([txL(x), tyL(f(x))]);
    return pts.map((pt,i) => `${i===0?'M':'L'}${pt[0].toFixed(1)},${pt[1].toFixed(1)}`).join(' ');
  };

  const scX = (PW - 28) / (b - a);
  const scY = 72;

  // Panel 1 — Midpoint / Left Riemann
  const cxP1 = p(0) + 14, cyP1 = 290;
  const txP1 = x => cxP1 + (x-a)*scX;
  const tyP1 = y => cyP1 - y*scY;

  // Panel 2 — Trapezoid
  const cxP2 = p(1) + 14, cyP2 = 290;
  const txP2 = x => cxP2 + (x-a)*scX;
  const tyP2 = y => cyP2 - y*scY;

  // Panel 3 — Simpson's
  const cxP3 = p(2) + 14, cyP3 = 290;
  const txP3 = x => cxP3 + (x-a)*scX;
  const tyP3 = y => cyP3 - y*scY;

  const trueVal = 0.5*(b-a) + (Math.cos(a*1.1)-Math.cos(b*1.1))/1.1*0.7 + 0.15*(b*b-a*a)/2;

  // Midpoint sum
  let midSum = 0;
  for (let i=0;i<n;i++) midSum += f((xs[i]+xs[i+1])/2) * h;
  // Trap sum
  let trapSum = 0;
  for (let i=0;i<n;i++) trapSum += (f(xs[i])+f(xs[i+1]))*h/2;
  // Simpson sum (n must be even; n=6 here)
  let simpSum = 0;
  for (let i=0;i<n;i+=2) {
    const xm = (xs[i]+xs[i+2])/2;
    simpSum += (f(xs[i]) + 4*f(xm) + f(xs[i+2])) * h/3;
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Numerical Integration — Midpoint, Trapezoid & Simpson's Rule on ∫f(x)dx</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {[0,1,2].map(pi => (
          <rect key={pi} x={p(pi)} y={8} width={PW} height={H-16} rx={5} fill="#fff" stroke="#ccd9ea"/>
        ))}

        {/* ── Panel 1: Midpoint Rule ── */}
        <text x={p(0)+PW/2} y={27} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">Midpoint Rule</text>
        <text x={p(0)+PW/2} y={42} textAnchor="middle" fontSize="10.5" fill="#2E75B6" fontFamily="'Courier New',monospace">∫≈ h·Σf(xᵢ + h/2)</text>

        {xs.slice(0,-1).map((xi,i) => {
          const xm = xi + h/2;
          const ym = f(xm);
          return (
            <g key={i}>
              <rect x={txP1(xi)} y={tyP1(ym)} width={Math.max(1,txP1(xi+h)-txP1(xi)-1)} height={cyP1-tyP1(ym)} fill="#2E75B6" fillOpacity="0.25" stroke="#2E75B6" strokeWidth="1"/>
              <circle cx={txP1(xm)} cy={tyP1(ym)} r={3} fill="#2E75B6"/>
            </g>
          );
        })}
        <path d={curveForPanel(txP1,tyP1,a-0.1,b+0.1)} fill="none" stroke="#1F3864" strokeWidth="2"/>
        <line x1={txP1(a-0.1)} y1={cyP1} x2={txP1(b+0.2)} y2={cyP1} stroke="#1F3864" strokeWidth="1.3"/>
        <line x1={txP1(a)} y1={cyP1+4} x2={txP1(a)} y2={cyP1-4} stroke="#1F3864" strokeWidth="1.5"/>
        <line x1={txP1(b)} y1={cyP1+4} x2={txP1(b)} y2={cyP1-4} stroke="#1F3864" strokeWidth="1.5"/>
        <text x={txP1(a)} y={cyP1+16} textAnchor="middle" fontSize="10" fill="#888">a</text>
        <text x={txP1(b)} y={cyP1+16} textAnchor="middle" fontSize="10" fill="#888">b</text>
        <rect x={p(0)+8} y={H-76} width={PW-16} height={60} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={p(0)+14} y={H-60} fontSize="11" fill="#1F3864" fontWeight="700">Error:  O(h²)</text>
        <text x={p(0)+14} y={H-43} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">Approx: {midSum.toFixed(4)}</text>
        <text x={p(0)+14} y={H-27} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">True:   {trueVal.toFixed(4)}</text>

        {/* ── Panel 2: Trapezoid Rule ── */}
        <text x={p(1)+PW/2} y={27} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">Trapezoid Rule</text>
        <text x={p(1)+PW/2} y={42} textAnchor="middle" fontSize="10.5" fill="#27ae60" fontFamily="'Courier New',monospace">∫≈ (h/2)·[f(x₀)+2f(x₁)+…+f(xₙ)]</text>

        {xs.slice(0,-1).map((xi,i) => {
          const xn = xs[i+1];
          const y0 = f(xi), y1 = f(xn);
          const pts = `${txP2(xi)},${tyP2(y0)} ${txP2(xn)},${tyP2(y1)} ${txP2(xn)},${cyP2} ${txP2(xi)},${cyP2}`;
          return <polygon key={i} points={pts} fill="#27ae60" fillOpacity="0.22" stroke="#27ae60" strokeWidth="1"/>;
        })}
        {xs.map((xi,i) => (
          <line key={i} x1={txP2(xi)} y1={cyP2} x2={txP2(xi)} y2={tyP2(f(xi))} stroke="#27ae60" strokeWidth="1.2" strokeDasharray="3,2"/>
        ))}
        <path d={curveForPanel(txP2,tyP2,a-0.1,b+0.1)} fill="none" stroke="#1F3864" strokeWidth="2"/>
        <line x1={txP2(a-0.1)} y1={cyP2} x2={txP2(b+0.2)} y2={cyP2} stroke="#1F3864" strokeWidth="1.3"/>
        <text x={txP2(a)} y={cyP2+16} textAnchor="middle" fontSize="10" fill="#888">a</text>
        <text x={txP2(b)} y={cyP2+16} textAnchor="middle" fontSize="10" fill="#888">b</text>
        <rect x={p(1)+8} y={H-76} width={PW-16} height={60} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={p(1)+14} y={H-60} fontSize="11" fill="#1F3864" fontWeight="700">Error:  O(h²)</text>
        <text x={p(1)+14} y={H-43} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">Approx: {trapSum.toFixed(4)}</text>
        <text x={p(1)+14} y={H-27} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">True:   {trueVal.toFixed(4)}</text>

        {/* ── Panel 3: Simpson's Rule ── */}
        <text x={p(2)+PW/2} y={27} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">Simpson's 1/3 Rule</text>
        <text x={p(2)+PW/2} y={42} textAnchor="middle" fontSize="10.5" fill="#c0392b" fontFamily="'Courier New',monospace">∫≈ (h/3)·[f₀+4f₁+2f₂+4f₃+…+fₙ]</text>

        {Array.from({length:n/2},(_,k)=>k).map(k => {
          const xi = xs[2*k], xm = xs[2*k+1], xn = xs[2*k+2];
          // Draw parabolic arc through 3 points
          const arcPts = [];
          for (let t=0; t<=1; t+=0.04) {
            const xx = xi + t*(xn-xi);
            // Lagrange interp through xi,xm,xn
            const L0 = (xx-xm)*(xx-xn)/((xi-xm)*(xi-xn));
            const L1 = (xx-xi)*(xx-xn)/((xm-xi)*(xm-xn));
            const L2 = (xx-xi)*(xx-xm)/((xn-xi)*(xn-xm));
            const yy = f(xi)*L0 + f(xm)*L1 + f(xn)*L2;
            arcPts.push([txP3(xx), tyP3(yy)]);
          }
          const arcPath = arcPts.map((pt,i) => `${i===0?'M':'L'}${pt[0].toFixed(1)},${pt[1].toFixed(1)}`).join(' ') +
            ` L${txP3(xn)},${cyP3} L${txP3(xi)},${cyP3} Z`;
          return <path key={k} d={arcPath} fill="#c0392b" fillOpacity="0.2" stroke="#c0392b" strokeWidth="1.2"/>;
        })}
        <path d={curveForPanel(txP3,tyP3,a-0.1,b+0.1)} fill="none" stroke="#1F3864" strokeWidth="2"/>
        <line x1={txP3(a-0.1)} y1={cyP3} x2={txP3(b+0.2)} y2={cyP3} stroke="#1F3864" strokeWidth="1.3"/>
        {xs.map((xi,i) => (
          <circle key={i} cx={txP3(xi)} cy={tyP3(f(xi))} r={3.5} fill="#c0392b" stroke="#fff" strokeWidth="1"/>
        ))}
        <text x={txP3(a)} y={cyP3+16} textAnchor="middle" fontSize="10" fill="#888">a</text>
        <text x={txP3(b)} y={cyP3+16} textAnchor="middle" fontSize="10" fill="#888">b</text>
        <rect x={p(2)+8} y={H-76} width={PW-16} height={60} rx={3} fill="#fff0f0" stroke="#c0392b" strokeWidth="1"/>
        <text x={p(2)+14} y={H-60} fontSize="11" fill="#1F3864" fontWeight="700">Error:  O(h⁴)  ← much better</text>
        <text x={p(2)+14} y={H-43} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">Approx: {simpSum.toFixed(4)}</text>
        <text x={p(2)+14} y={H-27} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">True:   {trueVal.toFixed(4)}</text>
      </svg>
      <div style={S.dCaption}>
        All three rules partition [a,b] into n subintervals of width h=(b−a)/n and approximate the integrand within each strip. The midpoint rule uses a rectangle at the midpoint of each strip (O(h²)). The trapezoid rule connects endpoints with straight lines (O(h²), but error has opposite sign to midpoint). Simpson's rule fits a parabola through three equally spaced points per pair of strips, achieving O(h⁴) — the most accurate of the three for smooth functions. In practice, doubling n with Simpson's reduces error by a factor of 16.
      </div>
    </div>
  );
}

// ── Diagram 3: Root Finding — Bisection & Newton-Raphson ──────────
function DiagramRootFinding() {
  const W = 900, H = 390;
  const f  = x => x*x*x - x - 1.8;
  const fp = x => 3*x*x - 1;

  // Bisection history [a,b] pairs
  const bisSteps = [];
  let ba=0.8, bb=2.0;
  for(let i=0;i<6;i++){
    const bm=(ba+bb)/2;
    bisSteps.push({a:ba,b:bb,m:bm,fa:f(ba),fm:f(bm)});
    if(f(ba)*f(bm)<0) bb=bm; else ba=bm;
  }

  // Newton-Raphson from x=2.0
  const nrSteps=[];
  let xn=2.0;
  for(let i=0;i<5;i++){
    const fn=f(xn), fpn=fp(xn);
    const xn1=xn-fn/fpn;
    nrSteps.push({x:xn, fx:fn, xn1});
    xn=xn1;
  }

  // Plot helpers
  const cx1=200,cy1=220,sc1=68;
  const tx1=x=>cx1+(x-1.4)*sc1, ty1=y=>cy1-y*sc1;
  const cx2=680,cy2=220,sc2=68;
  const tx2=x=>cx2+(x-1.4)*sc2, ty2=y=>cy2-y*sc2;

  const cvD1 = (() => {
    const pts=[];
    for(let x=0.6;x<=2.2;x+=0.04){const y=f(x);if(Math.abs(y)<3)pts.push([tx1(x),ty1(y)]);}
    return pts.map((p,i)=>`${i===0?'M':'L'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ');
  })();
  const cvD2 = (() => {
    const pts=[];
    for(let x=0.6;x<=2.3;x+=0.04){const y=f(x);if(Math.abs(y)<3)pts.push([tx2(x),ty2(y)]);}
    return pts.map((p,i)=>`${i===0?'M':'L'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ');
  })();

  const root=1.5213; // x³-x-1.8=0 approx

  const colors=['#2E75B6','#27ae60','#e07b00','#9b59b6','#c0392b','#1F3864'];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Root Finding — Bisection Method (left) vs Newton-Raphson Method (right)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* ── Left: Bisection ── */}
        <rect x={8} y={8} width={434} height={H-16} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={225} y={27} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Bisection Method  f(x) = x³−x−1.8</text>

        {/* Axes */}
        {[0.8,1.0,1.2,1.4,1.6,1.8,2.0].map(v=>(
          <g key={v}>
            <line x1={tx1(v)} y1={50} x2={tx1(v)} y2={H-50} stroke="#f0f0f0" strokeWidth="1"/>
            <text x={tx1(v)} y={H-34} textAnchor="middle" fontSize="9" fill="#bbb">{v}</text>
          </g>
        ))}
        {[-2,-1,0,1,2].map(v=>(
          <g key={v}>
            <line x1={tx1(0.6)} y1={ty1(v)} x2={tx1(2.2)} y2={ty1(v)} stroke="#f0f0f0" strokeWidth="1"/>
            {v!==0 && <text x={tx1(0.6)-4} y={ty1(v)+4} textAnchor="end" fontSize="9" fill="#bbb">{v}</text>}
          </g>
        ))}
        <line x1={tx1(0.6)} y1={cy1} x2={tx1(2.2)} y2={cy1} stroke="#1F3864" strokeWidth="1.5"/>
        <line x1={tx1(1.4)} y1={50} x2={tx1(1.4)} y2={H-46} stroke="#1F3864" strokeWidth="1.5"/>
        <text x={tx1(2.2)+5} y={cy1+4} fontSize="11" fill="#1F3864" fontWeight="700">x</text>

        {/* Interval brackets for each bisection step */}
        {bisSteps.slice(0,5).map(({a,b,m},i) => (
          <g key={i}>
            <line x1={tx1(a)} y1={50+i*26} x2={tx1(b)} y2={50+i*26} stroke={colors[i]} strokeWidth="2"/>
            <line x1={tx1(a)} y1={44+i*26} x2={tx1(a)} y2={56+i*26} stroke={colors[i]} strokeWidth="1.5"/>
            <line x1={tx1(b)} y1={44+i*26} x2={tx1(b)} y2={56+i*26} stroke={colors[i]} strokeWidth="1.5"/>
            <circle cx={tx1(m)} cy={50+i*26} r={4} fill={colors[i]} stroke="#fff" strokeWidth="1.5"/>
            <text x={tx1(m)+6} y={50+i*26+4} fontSize="9.5" fill={colors[i]} fontWeight="700">step {i+1}: m={m.toFixed(4)}</text>
          </g>
        ))}

        {/* Curve */}
        <path d={cvD1} fill="none" stroke="#1F3864" strokeWidth="2.2"/>
        {/* Root */}
        <circle cx={tx1(root)} cy={ty1(0)} r={6} fill="#c0392b" stroke="#fff" strokeWidth="2"/>
        <text x={tx1(root)+8} y={ty1(0)-8} fontSize="11" fill="#c0392b" fontWeight="700">root≈{root}</text>

        {/* Convergence rate box */}
        <rect x={16} y={H-68} width={418} height={52} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={24} y={H-53} fontSize="11" fill="#1F3864" fontWeight="700">Algorithm:  while |b−a|&gt;tol:  m=(a+b)/2;  if f(a)·f(m)&lt;0: b=m  else: a=m</text>
        <text x={24} y={H-36} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">Convergence: linear — each step halves the interval.  n steps → error ≤ (b−a)/2ⁿ</text>
        <text x={24} y={H-20} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">Guaranteed to converge if f(a)·f(b)&lt;0  (sign change brackets a root)</text>

        {/* ── Right: Newton-Raphson ── */}
        <rect x={450} y={8} width={442} height={H-16} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={671} y={27} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Newton-Raphson  xₙ₊₁ = xₙ − f(xₙ)/f'(xₙ)</text>

        {[0.8,1.0,1.2,1.4,1.6,1.8,2.0].map(v=>(
          <g key={v}>
            <line x1={tx2(v)} y1={50} x2={tx2(v)} y2={H-50} stroke="#f0f0f0" strokeWidth="1"/>
            <text x={tx2(v)} y={H-34} textAnchor="middle" fontSize="9" fill="#bbb">{v}</text>
          </g>
        ))}
        {[-2,-1,0,1,2].map(v=>(
          <g key={v}>
            <line x1={tx2(0.6)} y1={ty2(v)} x2={tx2(2.3)} y2={ty2(v)} stroke="#f0f0f0" strokeWidth="1"/>
          </g>
        ))}
        <line x1={tx2(0.6)} y1={cy2} x2={tx2(2.3)} y2={cy2} stroke="#1F3864" strokeWidth="1.5"/>
        <line x1={tx2(1.4)} y1={50} x2={tx2(1.4)} y2={H-46} stroke="#1F3864" strokeWidth="1.5"/>
        <text x={tx2(2.3)+5} y={cy2+4} fontSize="11" fill="#1F3864" fontWeight="700">x</text>

        {/* Curve */}
        <path d={cvD2} fill="none" stroke="#1F3864" strokeWidth="2.2"/>
        {/* Root */}
        <circle cx={tx2(root)} cy={ty2(0)} r={6} fill="#c0392b" stroke="#fff" strokeWidth="2"/>

        {/* NR tangent lines */}
        {nrSteps.slice(0,4).map(({x,fx,xn1},i)=>{
          const slope=fp(x);
          const x1ext=Math.min(x+0.5, 2.25), x0ext=Math.max(x-0.1, 0.65);
          const col=colors[i];
          return (
            <g key={i}>
              {/* Vertical drop from xn to curve */}
              <line x1={tx2(x)} y1={cy2} x2={tx2(x)} y2={ty2(fx)} stroke={col} strokeWidth="1.5" strokeDasharray="3,2"/>
              {/* Tangent line */}
              <line
                x1={tx2(x0ext)} y1={ty2(fx+slope*(x0ext-x))}
                x2={tx2(x1ext)} y2={ty2(fx+slope*(x1ext-x))}
                stroke={col} strokeWidth="1.8"
              />
              {/* Point on curve */}
              <circle cx={tx2(x)} cy={ty2(fx)} r={4.5} fill={col} stroke="#fff" strokeWidth="1.5"/>
              {/* x_{n+1} tick */}
              <line x1={tx2(xn1)} y1={cy2-5} x2={tx2(xn1)} y2={cy2+5} stroke={col} strokeWidth="1.5"/>
              <text x={tx2(x)+5} y={ty2(fx)-8} fontSize="9.5" fill={col} fontWeight="700">x{i}</text>
            </g>
          );
        })}

        {/* Convergence rate box */}
        <rect x={458} y={H-68} width={426} height={52} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={466} y={H-53} fontSize="11" fill="#1F3864" fontWeight="700">Algorithm:  xₙ₊₁ = xₙ − f(xₙ)/f'(xₙ)  until |f(xₙ)|&lt;tol</text>
        <text x={466} y={H-36} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">Convergence: quadratic — correct digits roughly double each step</text>
        <text x={466} y={H-20} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">Risk: diverges if x₀ far from root, or if f'(xₙ)≈0  (near flat region)</text>
      </svg>
      <div style={S.dCaption}>
        Bisection brackets a root with a guaranteed sign-change interval and halves it each step — slow (linear convergence) but completely reliable. Newton-Raphson draws the tangent line at the current guess and uses its x-intercept as the next guess — extremely fast (quadratic convergence: 4 correct digits → 8 → 16) but requires f' and can fail if the initial guess is poor. In engineering practice, bisection is used to get a close starting point, then Newton-Raphson finishes it off.
      </div>
    </div>
  );
}

// ── Diagram 4: Euler & Runge-Kutta ODE Solvers ───────────────────
function DiagramODESolvers() {
  const W = 900, H = 390;

  // dy/dx = -0.5*y + sin(x),  y(0)=2
  const fODE = (x,y) => -0.6*y + Math.sin(x*1.2);
  // True solution (approx via very small steps)
  const trueSol = (() => {
    const pts=[[0,2]];
    const hTrue=0.01;
    for(let i=0;i<Math.round(8/hTrue);i++){
      const [x,y]=pts[pts.length-1];
      const k1=fODE(x,y), k2=fODE(x+hTrue/2,y+hTrue*k1/2);
      const k3=fODE(x+hTrue/2,y+hTrue*k2/2), k4=fODE(x+hTrue,y+hTrue*k3);
      pts.push([x+hTrue, y+hTrue*(k1+2*k2+2*k3+k4)/6]);
    }
    return pts;
  })();

  // Euler with h=1.0
  const eulerH1 = [[0,2]];
  const H1=1.0;
  for(let i=0;i<8;i++){
    const [x,y]=eulerH1[eulerH1.length-1];
    eulerH1.push([x+H1, y+H1*fODE(x,y)]);
  }

  // Euler with h=0.4
  const eulerH04 = [[0,2]];
  const H04=0.4;
  for(let i=0;i<20;i++){
    const [x,y]=eulerH04[eulerH04.length-1];
    eulerH04.push([x+H04, y+H04*fODE(x,y)]);
  }

  // RK4 with h=1.0
  const rk4H1 = [[0,2]];
  for(let i=0;i<8;i++){
    const [x,y]=rk4H1[rk4H1.length-1];
    const k1=fODE(x,y), k2=fODE(x+H1/2,y+H1*k1/2);
    const k3=fODE(x+H1/2,y+H1*k2/2), k4=fODE(x+H1,y+H1*k3);
    rk4H1.push([x+H1, y+H1*(k1+2*k2+2*k3+k4)/6]);
  }

  const cx=120, cy=270, scX=90, scY=70;
  const tx=x=>cx+x*scX;
  const ty=y=>cy-y*scY;

  const toPath=pts=>pts.filter(([x])=>x<=8.05).map(([x,y],i)=>`${i===0?'M':'L'}${tx(x).toFixed(1)},${ty(y).toFixed(1)}`).join(' ');

  // Right: RK4 stage diagram
  const stageX=530, stageY=180, stageSc=110;
  const xt=x=>stageX+x*stageSc, yt=y=>stageY-y*70;
  const xStep=1.0, y0=1.4;
  const k1s=fODE(0,y0), k2s=fODE(xStep/2,y0+xStep*k1s/2);
  const k3s=fODE(xStep/2,y0+xStep*k2s/2), k4s=fODE(xStep,y0+xStep*k3s);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>ODE Solvers — Euler Method vs Runge-Kutta 4 on  y' = −0.6y + sin(1.2x),  y(0)=2</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Left: comparative plot */}
        <rect x={8} y={8} width={490} height={H-16} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={253} y={27} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Solution Comparison (same step h=1.0 for Euler and RK4)</text>

        {[0,2,4,6,8].map(v=>(
          <g key={v}>
            <line x1={tx(v)} y1={50} x2={tx(v)} y2={H-50} stroke="#f0f0f0" strokeWidth="1"/>
            <text x={tx(v)} y={H-34} textAnchor="middle" fontSize="10" fill="#bbb">{v}</text>
          </g>
        ))}
        {[-0.5,0,0.5,1,1.5,2].map(v=>(
          <g key={v}>
            <line x1={tx(0)} y1={ty(v)} x2={tx(8.1)} y2={ty(v)} stroke="#f0f0f0" strokeWidth="1"/>
            {v!==0&&<text x={tx(0)-4} y={ty(v)+4} textAnchor="end" fontSize="9" fill="#bbb">{v}</text>}
          </g>
        ))}
        <line x1={tx(0)} y1={cy} x2={tx(8.1)} y2={cy} stroke="#1F3864" strokeWidth="1.4"/>
        <line x1={tx(0)} y1={50} x2={tx(0)} y2={H-46} stroke="#1F3864" strokeWidth="1.4"/>
        <text x={tx(8.1)+5} y={cy+4} fontSize="11" fill="#1F3864" fontWeight="700">x</text>
        <text x={tx(0)+4} y={48} fontSize="11" fill="#1F3864" fontWeight="700">y</text>

        {/* True solution */}
        <path d={toPath(trueSol)} fill="none" stroke="#1F3864" strokeWidth="2.5"/>

        {/* Euler h=1.0 */}
        <path d={toPath(eulerH1)} fill="none" stroke="#e07b00" strokeWidth="2" strokeDasharray="7,3"/>
        {eulerH1.filter(([x])=>x<=8.0).map(([x,y],i)=>(
          <circle key={i} cx={tx(x)} cy={ty(y)} r={4} fill="#e07b00" stroke="#fff" strokeWidth="1.5"/>
        ))}

        {/* Euler h=0.4 */}
        <path d={toPath(eulerH04)} fill="none" stroke="#9b59b6" strokeWidth="1.5" strokeDasharray="4,3"/>

        {/* RK4 h=1.0 */}
        <path d={toPath(rk4H1)} fill="none" stroke="#27ae60" strokeWidth="2.2" strokeDasharray="7,3"/>
        {rk4H1.filter(([x])=>x<=8.0).map(([x,y],i)=>(
          <circle key={i} cx={tx(x)} cy={ty(y)} r={4} fill="#27ae60" stroke="#fff" strokeWidth="1.5"/>
        ))}

        {/* Legend */}
        {[
          ['#1F3864','True solution (h=0.01 RK4)',''],
          ['#e07b00','Euler  h=1.0','--- dashed'],
          ['#9b59b6','Euler  h=0.4','--- dashed'],
          ['#27ae60','RK4    h=1.0','--- dashed'],
        ].map(([col,lbl,dash],i)=>(
          <g key={i}>
            <line x1={18} y1={H-80+i*18} x2={44} y2={H-80+i*18} stroke={col} strokeWidth={i===0?2.5:2} strokeDasharray={i>0?'5,3':undefined}/>
            <text x={50} y={H-75+i*18} fontSize="10.5" fill={col} fontWeight="700">{lbl}</text>
          </g>
        ))}

        {/* Right: RK4 stage explanation */}
        <rect x={506} y={8} width={386} height={H-16} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={699} y={27} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">RK4 — Four Slope Estimates per Step</text>

        {[
          {y:38, bg:'#EBF3FB', bc:'#2E75B6', k:'k₁', desc:'Slope at start of interval', formula:'k₁ = f(xₙ, yₙ)'},
          {y:104, bg:'#f0fff4', bc:'#27ae60', k:'k₂', desc:'Slope at midpoint using k₁', formula:'k₂ = f(xₙ+h/2, yₙ+h·k₁/2)'},
          {y:170, bg:'#fff7ee', bc:'#e07b00', k:'k₃', desc:'Slope at midpoint using k₂', formula:'k₃ = f(xₙ+h/2, yₙ+h·k₂/2)'},
          {y:236, bg:'#fff0f0', bc:'#c0392b', k:'k₄', desc:'Slope at end using k₃', formula:'k₄ = f(xₙ+h, yₙ+h·k₃)'},
        ].map(({y,bg,bc,k,desc,formula})=>(
          <g key={k}>
            <rect x={514} y={y} width={370} height={56} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={522} y={y+16} fontSize="12" fill="#1F3864" fontWeight="700">{k} — {desc}</text>
            <text x={522} y={y+34} fontSize="11" fill={bc} fontFamily="'Courier New',monospace" fontWeight="700">{formula}</text>
          </g>
        ))}

        {/* Weighted average box */}
        <rect x={514} y={300} width={370} height={76} rx={3} fill="#1F3864" fillOpacity="0.06" stroke="#1F3864" strokeWidth="1.2"/>
        <text x={699} y={318} textAnchor="middle" fontSize="12" fill="#1F3864" fontWeight="700">Weighted Average Step</text>
        <text x={522} y={336} fontSize="11" fill="#2E75B6" fontFamily="'Courier New',monospace" fontWeight="700">yₙ₊₁ = yₙ + (h/6)·(k₁ + 2k₂ + 2k₃ + k₄)</text>
        <text x={522} y={354} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">Weights: 1/6, 2/6, 2/6, 1/6  (Simpson-like)</text>
        <text x={522} y={370} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">Error: O(h⁵) per step → O(h⁴) global  (vs Euler O(h))</text>
      </svg>
      <div style={S.dCaption}>
        Euler's method steps forward using the slope at the current point only — simple but accumulates error quickly (global error O(h)). RK4 computes four slope estimates per step: at the start, twice at the midpoint with improved estimates, and once at the end, then takes a weighted average. The result is O(h⁴) global accuracy — halving h reduces error by a factor of 16. For the same step size h=1.0, RK4 tracks the true solution almost exactly while Euler has already drifted significantly.
      </div>
    </div>
  );
}

// ── Diagram 5: Interpolation & Splines ───────────────────────────
function DiagramInterpolation() {
  const W = 900, H = 370;

  // Data points
  const data = [[0,1.0],[1,2.4],[2,1.8],[3,3.2],[4,2.1],[5,3.6]];

  const cx=90, cy=290, scX=115, scY=62;
  const tx=x=>cx+x*scX, ty=y=>cy-y*scY;

  // Linear interpolation between consecutive points
  const linPts=[];
  for(let i=0;i<data.length-1;i++){
    const [x0,y0]=data[i],[x1,y1]=data[i+1];
    for(let t=0;t<=1;t+=0.05) linPts.push([tx(x0+t*(x1-x0)),ty(y0+t*(y1-y0))]);
  }

  // Lagrange polynomial (degree 5 through all 6 points)
  const lagrange=x=>{
    let sum=0;
    for(let i=0;i<data.length;i++){
      let L=1;
      for(let j=0;j<data.length;j++) if(j!==i) L*=(x-data[j][0])/(data[i][0]-data[j][0]);
      sum+=data[i][1]*L;
    }
    return sum;
  };
  const lagPts=[];
  for(let x=-0.1;x<=5.1;x+=0.04){
    const y=lagrange(x);
    if(Math.abs(y)<6) lagPts.push([tx(x),ty(y)]);
  }

  // Cubic spline (natural) — manual coefficients for 5 intervals
  // Use simple clamped approximation via finite differences
  const splinePts=[];
  for(let i=0;i<data.length-1;i++){
    const [x0,y0]=data[i],[x1,y1]=data[i+1];
    const h=x1-x0;
    // Simple Hermite-like with centred differences for slopes
    const m0= i>0 ? (data[i+1][1]-data[i-1][1])/(data[i+1][0]-data[i-1][0]) : (y1-y0)/h;
    const m1= i<data.length-2 ? (data[i+2][1]-data[i][1])/(data[i+2][0]-data[i][0]) : (y1-y0)/h;
    for(let t=0;t<=1;t+=0.04){
      const h00=2*t*t*t-3*t*t+1, h10=t*t*t-2*t*t+t, h01=-2*t*t*t+3*t*t, h11=t*t*t-t*t;
      const y=h00*y0+h10*h*m0+h01*y1+h11*h*m1;
      splinePts.push([tx(x0+t*h),ty(y)]);
    }
  }

  const PW=(W-28)/2, p0=8, p1=8+PW+12;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Interpolation — Linear vs Lagrange Polynomial vs Cubic Spline</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Left panel: all three on one plot */}
        <rect x={p0} y={8} width={PW} height={H-16} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={p0+PW/2} y={27} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Three Interpolation Methods Through 6 Data Points</text>

        {/* Grid */}
        {data.map(([x])=>(
          <g key={x}>
            <line x1={tx(x)} y1={50} x2={tx(x)} y2={cy+4} stroke="#f0f0f0" strokeWidth="1"/>
            <text x={tx(x)} y={cy+18} textAnchor="middle" fontSize="10" fill="#bbb">{x}</text>
          </g>
        ))}
        {[0,1,2,3,4].map(v=>(
          <g key={v}>
            <line x1={tx(-0.1)} y1={ty(v)} x2={tx(5.2)} y2={ty(v)} stroke="#f0f0f0" strokeWidth="1"/>
            {v>0&&<text x={tx(-0.1)-4} y={ty(v)+4} textAnchor="end" fontSize="10" fill="#bbb">{v}</text>}
          </g>
        ))}
        <line x1={tx(-0.1)} y1={cy} x2={tx(5.2)} y2={cy} stroke="#1F3864" strokeWidth="1.3"/>
        <line x1={tx(0)} y1={50} x2={tx(0)} y2={cy+4} stroke="#1F3864" strokeWidth="1.3"/>
        <text x={tx(5.2)+5} y={cy+4} fontSize="11" fill="#1F3864" fontWeight="700">x</text>

        {/* Linear interp */}
        <path d={linPts.map((p,i)=>`${i===0?'M':'L'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ')} fill="none" stroke="#e07b00" strokeWidth="1.8"/>

        {/* Lagrange */}
        <path d={lagPts.map((p,i)=>`${i===0?'M':'L'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ')} fill="none" stroke="#c0392b" strokeWidth="1.8" strokeDasharray="5,3"/>

        {/* Spline */}
        <path d={splinePts.map((p,i)=>`${i===0?'M':'L'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ')} fill="none" stroke="#27ae60" strokeWidth="2.2"/>

        {/* Data points */}
        {data.map(([x,y],i)=>(
          <circle key={i} cx={tx(x)} cy={ty(y)} r={6} fill="#1F3864" stroke="#fff" strokeWidth="2"/>
        ))}

        {/* Legend */}
        {[['#e07b00','Linear (piecewise)'],['#c0392b','Lagrange (degree 5)'],['#27ae60','Cubic Spline']].map(([col,lbl],i)=>(
          <g key={i}>
            <line x1={p0+14} y1={H-82+i*20} x2={p0+38} y2={H-82+i*20} stroke={col} strokeWidth={i===1?undefined:2} strokeDasharray={i===1?'5,3':undefined}/>
            {i!==1 && <line x1={p0+14} y1={H-82+i*20} x2={p0+38} y2={H-82+i*20} stroke={col} strokeWidth="2"/>}
            <text x={p0+44} y={H-77+i*20} fontSize="10.5" fill={col} fontWeight="700">{lbl}</text>
          </g>
        ))}

        {/* Right panel: explanation cards */}
        <rect x={p1} y={8} width={PW} height={H-16} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={p1+PW/2} y={27} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Method Properties</text>

        {[
          {y:36,  bg:'#fff7ee', bc:'#e07b00', title:'Linear Interpolation',
           lines:['Connect consecutive points with straight lines','C⁰ continuous — function matches at nodes','Discontinuous slope at each data point','Error ∝ h² · f\'\'  (proportional to curvature)']},
          {y:156, bg:'#fff0f0', bc:'#c0392b', title:'Lagrange Polynomial (degree n-1)',
           lines:['Single polynomial through all n points','C∞ smooth — infinitely differentiable','Runge\'s phenomenon: oscillates wildly at edges','Avoid for n>6; use splines instead']},
          {y:268, bg:'#f0fff4', bc:'#27ae60', title:'Cubic Spline',
           lines:['Piecewise degree-3 polynomials on each interval','C² continuous — smooth 1st and 2nd derivatives','Minimises total curvature ∫(y\'\')² dx','Best general-purpose choice for smooth data']},
        ].map(({y,bg,bc,title,lines})=>(
          <g key={title}>
            <rect x={p1+8} y={y} width={PW-16} height={96} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={p1+16} y={y+16} fontSize="12" fill="#1F3864" fontWeight="700">{title}</text>
            {lines.map((ln,i)=>(
              <text key={i} x={p1+16} y={y+34+i*16} fontSize="10.5" fill="#444" fontFamily="'Courier New',monospace">{ln}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Interpolation constructs a smooth function that passes exactly through a set of data points. Linear interpolation is simple but produces corners at every node. Lagrange polynomials are smooth but prone to wild oscillation between points (Runge's phenomenon) for large datasets. Cubic splines thread a smooth piecewise-cubic curve through all points while guaranteeing continuous first and second derivatives — this is why CAD software, animation, and FEA use splines for shape representation.
      </div>
    </div>
  );
}

// ── Diagram 6: Error & Convergence ───────────────────────────────
function DiagramErrorConvergence() {
  const W = 900, H = 340;

  // Log-log plot: error vs h for different methods
  const hVals = [0.5, 0.25, 0.125, 0.0625, 0.03125];
  const logH = hVals.map(h => Math.log10(h));
  const logHMin = Math.log10(0.025), logHMax = Math.log10(0.6);

  // Error models: E = C * h^p
  const methods = [
    { label:'Forward Diff  O(h¹)',   p:1, C:0.8,  color:'#e07b00' },
    { label:'Centred Diff  O(h²)',   p:2, C:0.5,  color:'#9b59b6' },
    { label:'Trapezoid Rule O(h²)',  p:2, C:0.3,  color:'#27ae60' },
    { label:"Simpson's Rule O(h⁴)", p:4, C:0.15, color:'#2E75B6' },
    { label:'RK4 Solver    O(h⁴)',  p:4, C:0.1,  color:'#c0392b' },
  ];

  const cx=140, cy=300, scX=520/(logHMax-logHMin), scY=240;
  const logEMin=-8, logEMax=0;
  const tx=lh=>cx+(lh-logHMin)*scX;
  const te=le=>cy+(le-logEMax)/(logEMin-logEMax)*scY;

  // Reference slopes
  const slopeAnnot = [
    { p:1, x:Math.log10(0.4), color:'#e07b00', label:'slope 1' },
    { p:2, x:Math.log10(0.35), color:'#27ae60', label:'slope 2' },
    { p:4, x:Math.log10(0.45), color:'#2E75B6', label:'slope 4' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Error & Convergence — Log-Log Plot of Error vs Step Size h</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Main plot area */}
        <rect x={8} y={8} width={640} height={H-16} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={328} y={27} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">log(Error) vs log(h) — Steeper slope = faster convergence</text>

        {/* Grid lines */}
        {[-1,-0.8,-0.6,-0.4,-0.2,0].map(lh=>(
          <g key={lh}>
            <line x1={tx(lh)} y1={50} x2={tx(lh)} y2={cy+4} stroke="#f0f0f0" strokeWidth="1"/>
            <text x={tx(lh)} y={cy+16} textAnchor="middle" fontSize="9" fill="#bbb">h={Math.pow(10,lh).toFixed(3)}</text>
          </g>
        ))}
        {[-7,-6,-5,-4,-3,-2,-1,0].map(le=>(
          <g key={le}>
            <line x1={cx-4} y1={te(le)} x2={tx(logHMax)+4} y2={te(le)} stroke="#f0f0f0" strokeWidth="1"/>
            <text x={cx-8} y={te(le)+4} textAnchor="end" fontSize="9" fill="#bbb">10^{le}</text>
          </g>
        ))}

        {/* Axes */}
        <line x1={cx} y1={cy} x2={tx(logHMax)+8} y2={cy} stroke="#1F3864" strokeWidth="1.4"/>
        <line x1={cx} y1={50} x2={cx} y2={cy+4} stroke="#1F3864" strokeWidth="1.4"/>
        <text x={tx(logHMax)+14} y={cy+4} fontSize="11" fill="#1F3864" fontWeight="700">h →</text>
        <text x={cx-4} y={46} textAnchor="middle" fontSize="11" fill="#1F3864" fontWeight="700">Error ↑</text>

        {/* Method lines */}
        {methods.map(({label,p,C,color})=>{
          const pts=hVals.map(h=>[tx(Math.log10(h)), te(Math.log10(C*Math.pow(h,p)))]).filter(([,y])=>y>=50&&y<=cy+4);
          if(pts.length<2) return null;
          const d=pts.map((pt,i)=>`${i===0?'M':'L'}${pt[0].toFixed(1)},${pt[1].toFixed(1)}`).join(' ');
          return (
            <g key={label}>
              <path d={d} fill="none" stroke={color} strokeWidth="2.2"/>
              {pts.map((pt,i)=><circle key={i} cx={pt[0]} cy={pt[1]} r={3.5} fill={color} stroke="#fff" strokeWidth="1.2"/>)}
            </g>
          );
        })}

        {/* Slope reference triangles */}
        {slopeAnnot.map(({p,x,color,label})=>{
          const dx=0.3, y0=te(Math.log10(0.3*Math.pow(Math.pow(10,x),p)));
          const y1=te(Math.log10(0.3*Math.pow(Math.pow(10,x+dx),p)));
          const x0=tx(x), x1=tx(x+dx);
          return (
            <g key={label}>
              <line x1={x0} y1={y0} x2={x1} y2={y0} stroke={color} strokeWidth="1" strokeDasharray="3,2"/>
              <line x1={x1} y1={y0} x2={x1} y2={y1} stroke={color} strokeWidth="1" strokeDasharray="3,2"/>
              <text x={(x0+x1)/2} y={y0+14} textAnchor="middle" fontSize="9" fill={color} fontWeight="700">{label}</text>
            </g>
          );
        })}

        {/* Annotations */}
        <text x={tx(Math.log10(0.03))} y={te(Math.log10(0.8*0.03))-10} fontSize="10" fill="#e07b00" fontWeight="700">O(h)</text>
        <text x={tx(Math.log10(0.03))} y={te(Math.log10(0.5*0.03*0.03))-10} fontSize="10" fill="#9b59b6" fontWeight="700">O(h²)</text>
        <text x={tx(Math.log10(0.25))} y={te(Math.log10(0.1*0.25**4))-10} fontSize="10" fill="#c0392b" fontWeight="700">O(h⁴)</text>

        {/* Right: legend + summary table */}
        <rect x={656} y={8} width={236} height={H-16} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={774} y={27} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">Method Summary</text>

        {methods.map(({label,p,color},i)=>(
          <g key={i}>
            <rect x={664} y={36+i*52} width={220} height={46} rx={3}
              fill={i%2===0?'#f5f9ff':'#fff'} stroke="#ccd9ea" strokeWidth="0.8"/>
            <line x1={670} y1={36+i*52+23} x2={692} y2={36+i*52+23} stroke={color} strokeWidth="2.2"/>
            <circle cx={681} cy={36+i*52+23} r={3.5} fill={color}/>
            <text x={698} y={36+i*52+16} fontSize="10" fill="#1F3864" fontWeight="700">{label.split('  ')[0]}</text>
            <text x={698} y={36+i*52+30} fontSize="10" fill={color} fontFamily="'Courier New',monospace" fontWeight="700">{label.split('  ')[1]}</text>
            <text x={698} y={36+i*52+44} fontSize="9.5" fill="#555">halve h → error /{Math.pow(2,p)}</text>
          </g>
        ))}

        <rect x={664} y={H-56} width={220} height={42} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={672} y={H-40} fontSize="10" fill="#1F3864" fontWeight="700">Round-off floor: h too small</text>
        <text x={672} y={H-24} fontSize="9.5" fill="#444" fontFamily="'Courier New',monospace">→ floating-point cancellation</text>
      </svg>
      <div style={S.dCaption}>
        On a log-log plot, methods with error O(hᵖ) appear as straight lines with slope p — a steeper line means faster convergence as h decreases. O(h⁴) methods (Simpson, RK4) converge 16× faster per halving than O(h) methods, which is why they dominate in practice. However, every method hits a round-off floor at very small h: subtracting two nearly equal floating-point numbers loses significant digits, so the optimal h balances truncation error and round-off error.
      </div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────
export default function NumericalMethods() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Numerical Methods in Calculus</h1>
      <p style={S.p}>
        Numerical methods are algorithms that approximate the operations of calculus — differentiation, integration, root-finding, and solving differential equations — using arithmetic on discrete numbers rather than symbolic manipulation. They exist because the vast majority of real engineering functions have no closed-form antiderivative, no algebraic root, and no exact analytical solution. A stress field in a complex geometry, a fluid flow around an airfoil, a temperature distribution in an assembly — all of these are solved numerically.
      </p>
      <p style={S.p}>
        The key idea running through every method on this page is the trade-off between step size and accuracy: a smaller step h gives a better approximation but costs more computation. The order of a method — O(h), O(h²), O(h⁴) — tells you exactly how that trade-off works.
      </p>

      <InfoBox title="Core principle: replace limits and integrals with finite approximations" items={[
        "Derivative: lim(h→0)[f(x+h)−f(x)]/h  →  use small but finite h",
        "Integral: lim(n→∞) Σf(xᵢ)Δx  →  use large but finite n",
        "Root: find x where f(x)=0  →  bracket and close in iteratively",
        "ODE: y' = f(x,y)  →  step forward one Δx at a time using slope estimates",
        "O(hᵖ) accuracy: halving h reduces error by 2ᵖ — higher p = much better",
        "Round-off floor: h cannot be made arbitrarily small due to floating-point arithmetic",
      ]}/>

      <h2 style={S.h2}>Numerical Differentiation</h2>
      <DiagramNumericalDiff/>
      <Table2 rows={[
        ["Forward difference  O(h)",   "f'(x) ≈ [f(x+h) − f(x)] / h\nDerived from Taylor: f(x+h) = f(x)+hf'+½h²f''+…\nTruncation error ≈ (h/2)f''(x)"],
        ["Backward difference  O(h)",  "f'(x) ≈ [f(x) − f(x−h)] / h\nSame order as forward; error has opposite sign\nUseful at right boundary where x+h is unavailable"],
        ["Centred difference  O(h²)",  "f'(x) ≈ [f(x+h) − f(x−h)] / (2h)\nForward and backward errors cancel at leading order\nPreferred for interior points — twice as accurate"],
        ["Second derivative",          "f''(x) ≈ [f(x+h) − 2f(x) + f(x−h)] / h²\nO(h²) accuracy; used in Laplacian and beam equations"],
        ["Choosing h",                 "Too large: truncation error dominates\nToo small: round-off cancellation destroys accuracy\nOptimal h ≈ √(ε_machine) ≈ 10⁻⁸ for double precision"],
        ["Richardson extrapolation",   "Combine two step sizes h and h/2 to cancel error term\nBoosts O(h²) → O(h⁴) with no extra function evaluations"],
        ["Partial derivatives",        "∂f/∂x ≈ [f(x+h,y)−f(x−h,y)] / (2h)\nSame finite difference formulas, applied per variable"],
      ]}/>

      <h2 style={S.h2}>Numerical Integration</h2>
      <DiagramNumericalIntegration/>
      <Table2 rows={[
        ["Midpoint rule",         "∫_a^b f dx ≈ h · Σ f(xᵢ + h/2)  for i=0…n-1\nh=(b-a)/n;  error ∝ h² f''  →  O(h²)"],
        ["Trapezoid rule",        "∫_a^b f dx ≈ (h/2)[f(x₀) + 2f(x₁) + … + 2f(xₙ₋₁) + f(xₙ)]\nError ∝ −h² f'' / 12  →  O(h²); opposite sign to midpoint"],
        ["Simpson's 1/3 rule",    "∫_a^b f dx ≈ (h/3)[f₀ + 4f₁ + 2f₂ + 4f₃ + … + fₙ]  (n even)\nFits parabola through each 3-point group  →  O(h⁴)"],
        ["Simpson's 3/8 rule",    "∫ ≈ (3h/8)[f₀ + 3f₁ + 3f₂ + 2f₃ + … + fₙ]  (n multiple of 3)\nOne order higher fit; rarely used over 1/3 rule"],
        ["Gaussian quadrature",   "∫₋₁¹ f dx ≈ Σ wᵢ f(xᵢ)  at optimal (non-uniform) nodes\nn points → exact for polynomials of degree 2n−1 — very efficient"],
        ["Composite rule",        "Apply simple rule on each of n subintervals\nDouble n → error drops by 2ᵖ (p=2 trap/mid, p=4 Simpson)"],
        ["Romberg integration",   "Richardson extrapolation applied to trapezoid sequence\nCombines T(h) and T(h/2) to get O(h⁴), then O(h⁶), etc."],
        ["Adaptive quadrature",   "Automatically refine h where curvature is high\nUsed in MATLAB quad(), Python scipy.integrate — error-controlled"],
      ]}/>

      <h2 style={S.h2}>Root Finding</h2>
      <DiagramRootFinding/>
      <Table2 rows={[
        ["Bisection method",      "Bracket [a,b] with f(a)·f(b)<0; set m=(a+b)/2\nHalve interval each step → linear convergence\nError after n steps ≤ (b−a)/2ⁿ; always converges"],
        ["Newton-Raphson",        "xₙ₊₁ = xₙ − f(xₙ)/f'(xₙ)\nTangent line at xₙ crosses x-axis at xₙ₊₁\nQuadratic convergence — correct digits roughly double per step"],
        ["Secant method",         "xₙ₊₁ = xₙ − f(xₙ)(xₙ−xₙ₋₁) / (f(xₙ)−f(xₙ₋₁))\nNewton without requiring f' — uses finite difference slope\nSuperlinear convergence (order ≈ 1.618)"],
        ["False position (Regula Falsi)", "Like bisection but use secant line instead of midpoint\nGuaranteed convergence (sign-change bracket); faster than bisection"],
        ["Fixed-point iteration", "Rewrite f(x)=0 as x=g(x); iterate xₙ₊₁=g(xₙ)\nConverges if |g'(x*)|<1 near root x*"],
        ["Convergence order",     "Linear (order 1): |eₙ₊₁| ≤ C|eₙ|  — bisection\nQuadratic (order 2): |eₙ₊₁| ≤ C|eₙ|²  — Newton-Raphson\nHigher order → fewer iterations for same precision"],
        ["Failure modes (NR)",    "f'(xₙ) = 0 → division by zero\nInitial guess too far from root → diverge or cycle\nMultiple roots nearby → jump to wrong root"],
        ["Engineering use",       "Finding natural frequencies (det[K−ω²M]=0)\nEquilibrium states in nonlinear systems\nPipe flow: implicit Colebrook equation for friction factor f"],
      ]}/>

      <h2 style={S.h2}>Numerical ODE Solvers</h2>
      <DiagramODESolvers/>
      <Table2 rows={[
        ["Euler method  O(h)",    "yₙ₊₁ = yₙ + h·f(xₙ,yₙ)\nUse slope at current point to step forward\nGlobal error O(h) — needs small h for accuracy"],
        ["Modified Euler (Heun)", "Predict: ỹ = yₙ + h·f(xₙ,yₙ)\nCorrect: yₙ₊₁ = yₙ + (h/2)[f(xₙ,yₙ)+f(xₙ₊₁,ỹ)]\nO(h²) — first predictor-corrector method"],
        ["Runge-Kutta 4 (RK4)",  "k₁=f(xₙ,yₙ); k₂=f(xₙ+h/2, yₙ+hk₁/2)\nk₃=f(xₙ+h/2, yₙ+hk₂/2); k₄=f(xₙ+h, yₙ+hk₃)\nyₙ₊₁=yₙ+(h/6)(k₁+2k₂+2k₃+k₄)  →  O(h⁴)"],
        ["Stability",             "Euler can go unstable if h > 2/|λ| (λ = stiffness eigenvalue)\nRK4 has larger stability region but still conditionally stable\nImplicit methods (e.g. backward Euler) are unconditionally stable"],
        ["Stiff ODEs",            "Very different time scales in one system (e.g. fast + slow decay)\nExplicit methods need tiny h → use implicit solvers (MATLAB ode15s)"],
        ["Step size control",     "Embedded RK methods (RK45): compare 4th and 5th order estimates\nAccept step if error < tol; otherwise halve h and retry\nUsed in scipy.solve_ivp, MATLAB ode45"],
        ["Systems of ODEs",       "y⃗' = F(x, y⃗); apply same methods component-wise\n2nd order ODE → convert to system: let v=y', then y'=v, v'=f"],
        ["Boundary value problems","Two-point BVP: conditions at both ends, not just x₀\nShooting method: guess y'(a), integrate, adjust to match y(b)"],
      ]}/>

      <h2 style={S.h2}>Interpolation & Splines</h2>
      <DiagramInterpolation/>
      <Table2 rows={[
        ["Linear interpolation",  "y = y₀ + (x−x₀)(y₁−y₀)/(x₁−x₀)\nPiecewise; C⁰ only — slope jumps at nodes\nError ≤ h²/8 · max|f''|"],
        ["Lagrange polynomial",   "P(x) = Σ yᵢ Lᵢ(x),  Lᵢ(x) = Π_{j≠i}(x−xⱼ)/(xᵢ−xⱼ)\nPasses through all n points; degree n−1\nRunge's phenomenon: oscillates for large n"],
        ["Newton's divided diff.", "P(x) = f[x₀] + f[x₀,x₁](x−x₀) + f[x₀,x₁,x₂](x−x₀)(x−x₁)+…\nSame polynomial as Lagrange; easier to update with new points"],
        ["Cubic spline",          "Piecewise degree-3 on each interval [xᵢ,xᵢ₊₁]\nC² continuous: function, 1st and 2nd derivative all match at nodes\n4n unknowns; 4n equations from continuity + boundary conditions"],
        ["Natural spline BC",     "y''(a) = y''(b) = 0  (zero curvature at endpoints)\nOther options: clamped (y' specified), not-a-knot (used in MATLAB)"],
        ["B-splines",             "Basis splines — local support (changing one point only affects nearby)\nUsed in CAD (NURBS), animation, FEA shape functions"],
        ["Hermite interpolation", "Matches both function values and derivatives at nodes\ny'ᵢ specified → C¹ piecewise cubic without global solve"],
        ["Nearest-neighbour",     "y = y at closest data point — O(1) but discontinuous\nUsed in lookup tables, image resizing (pixel replication)"],
      ]}/>

      <h2 style={S.h2}>Error, Convergence & Method Selection</h2>
      <DiagramErrorConvergence/>
      <Table2 rows={[
        ["Truncation error",      "Error from replacing limit/integral with finite approximation\nDetermined by Taylor series — leading neglected term\nO(hᵖ): halving h reduces error by factor 2ᵖ"],
        ["Round-off error",       "Floating-point numbers have ~15 significant digits (double)\nSubtracting nearly equal numbers loses digits ('catastrophic cancellation')\nDominates when h is very small (h < ~10⁻⁸)"],
        ["Global vs local error", "Local: error in one step\nGlobal: accumulated over all steps from a to b\nGlobal = O(hᵖ) when local = O(hᵖ⁺¹) for ODE solvers"],
        ["Order of accuracy p",   "Found from slope on log-log error vs h plot\nForward diff: slope 1;  Centred diff: slope 2;  RK4: slope 4\nDouble-precision limit: error floor ~10⁻¹⁵"],
        ["Consistency",           "Method is consistent if truncation error → 0 as h → 0\nNecessary but not sufficient for convergence"],
        ["Stability",             "Errors do not grow unboundedly as computation proceeds\nConditional: stable only for h < h_max;  Unconditional: always stable"],
        ["Convergence",           "Lax Equivalence Theorem: consistent + stable → convergent\nConvergent: numerical solution → true solution as h → 0"],
        ["Method selection guide","Need integral, smooth f, high accuracy? → Simpson's or Gaussian quad\nNeed ODE, general use? → RK4 or adaptive RK45\nNeed root, no derivative? → Bisection to bracket, Secant to finish\nNeed interpolation, smooth? → Cubic spline\nNeed speed over accuracy? → Lower-order methods with larger h"],
      ]}/>

      <InfoBox title="Key Takeaway — Choosing the Right Numerical Method" items={[
        "Differentiating data? → Centred difference (O(h²)) unless at boundary, then forward/backward",
        "Integrating smooth function? → Simpson's rule (O(h⁴)) or Gaussian quadrature",
        "Integrating tabulated/irregular data? → Trapezoid rule (robust) or adaptive quadrature",
        "Finding a root, guaranteed? → Bisection to narrow down, then Newton-Raphson to converge fast",
        "Solving ODE, general purpose? → RK4 with h chosen by error estimate (use RK45 adaptively)",
        "Solving stiff ODE (very different timescales)? → Implicit solver (backward Euler, MATLAB ode15s)",
        "Interpolating smooth data, few points? → Cubic spline (C² smooth, no oscillation)",
        "Interpolating many points? → Never use high-degree Lagrange; use splines or piecewise methods",
        "Always check: halve h and rerun — if error drops by 2ᵖ you have order-p convergence",
      ]}/>
    </div>
  );
}